import { supabase } from '../../lib/supabaseClient';

export interface EmailTemplate {
  id: string;
  name: string;
  description: string | null;
  category: string;
  body_html: string;
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export async function listEmailTemplates(activeOnly: boolean): Promise<EmailTemplate[]> {
  // table absente de database.types.ts tant que MCP supabase-cime n'a pas régénéré
  let q = (supabase as any).from('email_templates').select('*')
    .order('display_order').order('name');
  if (activeOnly) q = q.eq('is_active', true);
  const { data, error } = await q;
  if (error) throw error;
  return (data ?? []) as EmailTemplate[];
}

export async function createEmailTemplate(
  input: Pick<EmailTemplate, 'name' | 'description' | 'category' | 'body_html'> & { is_active?: boolean },
): Promise<EmailTemplate> {
  // table absente de database.types.ts tant que MCP supabase-cime n'a pas régénéré
  const { data, error } = await (supabase as any).from('email_templates')
    .insert(input).select().single();
  if (error) throw error;
  return data as EmailTemplate;
}

export async function updateEmailTemplate(
  id: string,
  patch: Partial<Pick<EmailTemplate, 'name' | 'description' | 'category' | 'body_html' | 'is_active' | 'display_order'>>,
): Promise<EmailTemplate> {
  // table absente de database.types.ts tant que MCP supabase-cime n'a pas régénéré
  const { data, error } = await (supabase as any).from('email_templates')
    .update({ ...patch, updated_at: new Date().toISOString() }).eq('id', id).select().single();
  if (error) throw error;
  return data as EmailTemplate;
}
